import { Box } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Container = styled(Box)`
  margin-top: 2rem;

  ${variables.mediaQuery.lessThan('desktop')`
    margin-top: 1rem;
  `}
`;

export const FilterContainer = styled.div`
  display: flex;
  margin: 24px 0 24px 0;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  button:first-child {
    margin-left: 0;
  }

  svg {
    width: 20px;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    background-color: ${colorTokens.background.light};
    margin: 0;
    flex-wrap: wrap;
  `}
`;

export const DateFilterContainer = styled(Box)`
  &.MuiBox-root {
    display: flex;
    grid-gap: 1rem;

    .MuiBox-root {
      display: flex;
      align-items: center;
      grid-gap: 1rem;

      .MuiFormControl-root {
        width: 200px;
        ${variables.mediaQuery.lessThan('desktop')`  
          width: 100%;     
        `}
      }

      ${variables.mediaQuery.lessThan('tablet')`   
          width: 100%;
      `}
    }
    ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;     
      align-items: flex-end;   
      grid-gap: 1rem;
      margin-bottom: 1rem;     
    `}
    ${variables.mediaQuery.lessThan('tablet')`   
       flex-direction: column;     
    `}
  }
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  grid-gap: 16px;
  margin-top: 8px;

  ${variables.mediaQuery.lessThan('desktop')`   
      justify-content: flex-start;
      margin-bottom: 0.5rem;
  `}

  ${variables.mediaQuery.lessThan('tablet')`   
     width: 100%;
     flex-wrap: wrap;
  `}
`;
